// GET LOGIN
export const GET_REQUEST_DASHBOARD = "GET_REQUEST_HOME";
export const GET_REQUEST_DASHBOARD_SUCCESS = "GET_REQUEST_HOME_SUCCESS";
export const GET_REQUEST_DASHBOARD_FAILURE = "GET_REQUEST_HOME_FAILURE";
